import React from 'react';

import { infoList } from 'data';
import { SubLayout } from 'layouts';
import { Container, List, ListItem, RowBox, Text } from 'styles';
import * as S from '../../components/modal/infoModal/InfoModalstyle';

export default function Legal({infoDataItem, title, path1, path2}) {
  const [content, setContent] = React.useState(infoDataItem);

  return (
    <>
      <SubLayout h2={title} moH2={title} path1={path1} path2={path2}>
        <Container $margin="auto" $padding="20px 20px 50px 20px" $tPadding="0 16px">
          {content?.content.map((item, index) => (
            <div key={`item_${index}`}>
              {item.refundTitle && (
                <Text $type="b24" $tType="b20" $color="primary900" $paddingBottom={10}>
                  {item.refundTitle}
                </Text>
              )}
              {item.subTitle && (
                <Text $type="b24" $tType="b20" $color="primary900" $padding="30px 0 10px">
                  {item.subTitle}
                </Text>
              )}
              {item.lineText &&
                item.lineText.map((text, index) => (
                  <RowBox
                    key={`item_${index}`}
                    $gap={4}
                    $paddingLeft={16}
                    $mPaddingLeft="0"
                    $paddingTop={index !== 0 && 6}
                  >
                    <Text>-</Text>
                    <Text $type="14" $whiteSpace="pre-wrap">
                      {text}
                    </Text>
                  </RowBox>
                ))}
              {item.mailText1 && (
                <Text $type="14" $whiteSpace="pre-wrap">
                  {item.mailText1}&nbsp;
                  <S.MailTo href={`mailto:${item.mailTo}`}>({item.mailTo})</S.MailTo>
                </Text>
              )}
              {item.mailText2 && (
                <Text $type="14" $whiteSpace="pre-wrap" $padding="10px 0">
                  {item.mailText2}&nbsp;
                  <S.MailTo href={`mailto:${item.mailTo}`}>({item.mailTo})</S.MailTo>
                </Text>
              )}
              <Text $type="14" $whiteSpace="pre-wrap">
                {item.text}
              </Text>
              {item.list && (
                <List $padding="10px 0 10px 30px">
                  {item.list.map((i, index) => (
                    <ListItem key={`i_${index}`} $style="disc">
                      {i}
                    </ListItem>
                  ))}
                </List>
              )}
              {item.text2 && (
                <Text $type="14" $whiteSpace="pre-wrap">
                  {item.text2}
                </Text>
              )}
            </div>
          ))}
        </Container>
      </SubLayout>
    </>
  );
}
